import { FormRule } from 'antd'

export const required = (message = '${label} is required') => ({
  required: true,
  message,
})

export const sameAs =
  (
    fieldName: string,
    message = 'Please fill the same value as before',
  ): FormRule =>
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue(fieldName) === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error(message))
    },
  })

export const email = (message = 'Please enter a valid email'): FormRule => ({
  type: 'email',
  message,
})
